// import Logger from './utils/logger'
var ARGUMENTS_ORDER = ['ec', 'ea', 'el', 'et']; // new version only: ec, et, but compatable previous one
// Default retrun api

function sendEventWrapper(global, AES) {
  var _send = function _send(data) {
    var ec = data.ec,
        ea = data.ea,
        el = data.el,
        _data$et = data.et,
        et = _data$et === void 0 ? 'CLK' : _data$et,
        xpath = data.xpath;
    delete data.ec;
    delete data.ea;
    delete data.el;
    delete data.et;
    delete data.xpath;
    data.p1 = ec;
    data.p2 = ea;
    data.p3 = el;
    data.p4 = et;
    data.p5 = xpath;

    try {
      AES.log('event', data);
    } catch (ex) {}
  };

  return function sendEvent() {
    var args = arguments;
    var data = {};

    if (args.length === 0) {
      var _global$console, _global$console$warn;

      (_global$console = global.console) === null || _global$console === void 0 ? void 0 : (_global$console$warn = _global$console.warn) === null || _global$console$warn === void 0 ? void 0 : _global$console$warn.call(_global$console, '[AES tracker-plugin-event]', 'At lease one augument');
      return;
    } // Check arguments


    for (var i = 0; i < args.length; i++) {
      var arg = args[i];

      if (i !== 0 && typeof arg === 'object' && i !== args.length - 1) {
        var _global$console2, _global$console2$warn;

        global === null || global === void 0 ? void 0 : (_global$console2 = global.console) === null || _global$console2 === void 0 ? void 0 : (_global$console2$warn = _global$console2.warn) === null || _global$console2$warn === void 0 ? void 0 : _global$console2$warn.call(_global$console2, '[AES tracker-plugin-event]', 'Only the last argument can be object type');
        return;
      }

      if (typeof arg === 'string' || typeof arg === 'number') {
        data[ARGUMENTS_ORDER[i]] = arg;
      } else if (typeof arg === 'object' && i === args.length - 1) {
        for (var _i in arg) {
          if (arg.hasOwnProperty(_i)) {
            data[_i] = arg[_i];
          }
        }
      }
    }

    _send(data);
  };
}

export default sendEventWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-event@1.2.5@@ali/aes-tracker-plugin-event/es/send.js
// module id = null
// module chunks = 